import { Component, OnInit, Input } from '@angular/core';
import { Subscription } from 'rxjs';
import { IUser } from 'src/app/models/user.model';
import { ZpDataService } from 'src/app/services/zp-data.service';
import { SideNavBarVisibilityService } from 'src/app/services/side-nav-bar-visibility.service';
import { UserInfoService } from 'src/app/services/user-info.service';
import { FormGroup } from '@angular/forms';
import { ThemeService } from 'src/app/theme/theme-service.service';

@Component({
  selector: 'app-reset-password-email-sent',
  templateUrl: './reset-password-email-sent.component.html',
  styleUrls: ['./reset-password-email-sent.component.scss']
})
export class ResetPasswordEmailSentComponent implements OnInit {
  public subscription: Subscription
  public myUser: IUser;
  @Input() public parentForm: FormGroup;

  constructor(
    private ZpDataService: ZpDataService,
    public sideNavBarVisibilityService: SideNavBarVisibilityService,
    private userInfoService: UserInfoService,
    public themeService: ThemeService) { }

  async ngOnInit() {
    await this.getMyUser();
    this.subscription = this.userInfoService.getMessage().subscribe(user => {
      this.myUser = JSON.parse(user);
    });
    this.sideNavBarVisibilityService.hideSideNav = true;
  }

  async getMyUser() {
    if (!this.myUser) {
      await this.ZpDataService.getUser();
    }
  }

}
